import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { Typography, Box, Link as MuiLink } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import ScienceRoundedIcon from '@mui/icons-material/ScienceRounded';
import './Experience.css';

const experiences = [
  {
    title: 'Software Engineer',
    company: 'Amazon',
    companyUrl: 'https://www.aboutamazon.com/',
    date: 'December 2024 - Present',
    location: 'Mexico City, Mexico',
    highlights: ['Amazonian enjoying the jungle.'],
    icon: <WorkIcon />,
  },
  {
    title: 'Artificial Intelligence Intern',
    company: 'Infosys Limited',
    companyUrl: 'https://www.infosys.com/',
    date: 'July 2024 - September 2024',
    location: 'Bengaluru, India',
    highlights: ['Did some AI for finance.'],
    icon: <WorkIcon />,
  },
  {
    title: 'Undergraduate CS Researcher',
    company: 'MIT Media Lab – FI',
    companyUrl: 'https://www.media.mit.edu/',
    date: 'November 2023 - December 2024',
    location: 'Cambridge, USA',
    highlights: [
      <>
        Collaboration with{' '}
        <MuiLink href="https://nathanww.github.io/" target="_blank" rel="noopener noreferrer" underline="hover">
          Dr. Nathan Whitmore
        </MuiLink>
        .
      </>,
      <>
        Researched a project similar to the Men in Black{' '}
        <MuiLink
          href="https://meninblack.fandom.com/wiki/Neuralyzer"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          Neuralyzer
        </MuiLink>{' '}
        to help people forget bad memories.
      </>,
    ],
    icon: <ScienceRoundedIcon />,
  },
  {
    title: 'Undergraduate AI Researcher',
    company: 'Harvard Medical School – FNNDSC',
    companyUrl: 'https://www.fnndsc.org/',
    date: 'July 2023 - July 2024',
    location: 'Boston, USA',
    highlights: ['Researched AI for baby brains at the FNNDSC.'],
    icon: <ScienceRoundedIcon />,
  },
  {
    title: 'Software Engineering Intern',
    company: 'Banorte Bank',
    companyUrl: 'https://www.banorte.com/',
    date: 'July 2023 - July 2024',
    location: 'Remote',
    highlights: [
      'Did internal bank full-stack software and SQL.',
      'Made problem tickets be solved faster.',
    ],
    icon: <WorkIcon />,
  },
  {
    title: 'Software Engineering Intern',
    company: 'Cemex',
    companyUrl: 'https://www.cemex.com/',
    date: 'May 2023 - December 2023',
    location: 'Remote',
    highlights: ['Did RecSys.', 'Enjoyed Taco Tuesdays.'],
    icon: <WorkIcon />,
  },
  {
    title: 'Software Product Sprinter',
    company: 'Google',
    companyUrl: 'https://www.google.com/',
    date: 'May 2022 - August 2022',
    location: 'Remote',
    highlights: ['Met cool people.', 'Developed a solution for mental health.'],
    icon: <WorkIcon />,
  },
];

const Experience = () => {
  return (
    <Box>
      <Typography variant="overline" sx={{ color: 'secondary.light', letterSpacing: 2 }}>
        Crafting resilient products
      </Typography>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
        Experience
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 640, mb: 4 }}>
        Roles where I have blended research-grade rigor with product execution, delivering AI-driven
        systems and experiences at scale.
      </Typography>
      <VerticalTimeline>
        {experiences.map((exp, index) => (
          <VerticalTimelineElement
            key={index}
            date={exp.date}
            icon={exp.icon}
            iconStyle={{
              background: 'linear-gradient(135deg, rgba(96,165,250,0.95), rgba(244,114,182,0.85))',
              color: '#020617',
            }}
            contentStyle={{
              background: 'rgba(15, 23, 42, 0.85)',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              boxShadow: '0 20px 60px rgba(15, 23, 42, 0.35)',
              borderRadius: '16px',
              color: '#e2e8f0',
            }}
            contentArrowStyle={{ borderRight: '7px solid rgba(30, 41, 59, 0.85)' }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
              <Typography variant="h6" component="h3">
                {exp.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {exp.location}
              </Typography>
            </Box>

            <Typography
              variant="subtitle1"
              component="p"
              sx={{ fontStyle: 'italic', marginTop: 1, color: 'text.secondary' }}
            >
              <MuiLink
                href={exp.companyUrl}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: 'inherit' }}
              >
                {exp.company}
              </MuiLink>
            </Typography>

            <Typography variant="body2" component="div" sx={{ color: 'text.secondary', mt: 1.5 }}>
              <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                {exp.highlights.map((item, idx) => (
                  <li key={idx} style={{ marginBottom: '0.5rem' }}>
                    {item}
                  </li>
                ))}
              </ul>
            </Typography>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </Box>
  );
};

export default Experience;
